// extracted by mini-css-extract-plugin
module.exports = {"root":"ListingCardPlaceholderList_root__B0vEU"};